import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['toggled', 'expandButton'];

  connect() {
    this.expandButtonTarget.setAttribute('aria-expanded', 'false');
  }

  toggle(event) {
    event.preventDefault();

    const ariaExpanded =
      this.expandButtonTarget.getAttribute('aria-expanded') === 'false';
    this.expandButtonTarget.setAttribute(
      'aria-expanded',
      ariaExpanded ? 'true' : 'false'
    );
    this.toggledTargets.forEach((target) => {
      target.classList.toggle('hidden');
    });
  }
}
